/**
 * Admin screen — platform admin hub for managing actors, controls, templates, and users.
 */
import { isPlatformAdmin } from '../services/auth';
import { sanitize } from '../services/utils';
import { renderFoldersScreen } from './folders';
import { renderActorCatalog } from './admin-actors';
import { renderControlCatalog } from './admin-controls';
import { renderTemplateMgmt } from './admin-templates';
import { renderUserMgmt } from './admin-users';

let _container: HTMLElement;

export function renderAdminScreen(container: HTMLElement): void {
  _container = container;

  if (!isPlatformAdmin()) {
    container.innerHTML = `
      <div style="display:flex;align-items:center;justify-content:center;height:100vh;color:var(--colorError)">
        <p>Platform admin access required.</p>
      </div>`;
    return;
  }

  container.innerHTML = `
    <div style="max-width:1000px;margin:0 auto;padding:24px">
      <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:24px">
        <div>
          <h1 style="font-size:20px;font-weight:700;color:var(--colorTextHeading)">Administration</h1>
          <p style="font-size:12px;color:var(--colorTextMuted)">Manage actors, controls, templates, and users.</p>
        </div>
        <button id="admin-back" style="padding:6px 14px;border-radius:6px;font-size:12px;cursor:pointer;border:1px solid var(--colorBorder);background:var(--colorBgElevated);color:var(--colorText)">Back to Folders</button>
      </div>
      <div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(220px,1fr));gap:12px" id="admin-cards">
        ${adminCard('actors', 'Actor Catalog', 'Manage the actor type palette — add, edit, hide, or retire actor types.', '48')}
        ${adminCard('controls', 'Controls & Actions', 'Manage security controls — add, edit, hide, or retire controls.', '47')}
        ${adminCard('templates', 'Templates', 'Manage worksheet templates — view versions, publish updates.', '8')}
        ${adminCard('users', 'Users', 'View users, manage platform roles.', '')}
        ${adminCard('folders', 'Folders', 'View all folders, manage member access and roles.', '')}
      </div>
      <div id="admin-content" style="margin-top:24px"></div>
    </div>
  `;

  document.getElementById('admin-back')?.addEventListener('click', () => { window.location.hash = 'folders'; });

  document.querySelectorAll('[data-admin-section]').forEach((el) => {
    el.addEventListener('click', () => {
      const section = (el as HTMLElement).dataset.adminSection!;
      window.location.hash = `admin/${section}`;
    });
  });
}

function adminCard(section: string, title: string, desc: string, count: string): string {
  return `
    <div data-admin-section="${section}" style="background:var(--colorBgCard);border:1px solid var(--colorBorder);border-radius:var(--radiusLg);padding:16px;cursor:pointer;transition:border-color .15s" onmouseover="this.style.borderColor='var(--colorAccent)'" onmouseout="this.style.borderColor='var(--colorBorder)'">
      <div style="font-size:13px;font-weight:600;color:var(--colorTextHeading);margin-bottom:4px">${title}</div>
      <div style="font-size:11px;color:var(--colorTextMuted);line-height:1.4;margin-bottom:8px">${desc}</div>
      ${count ? `<div style="font-size:10px;color:var(--colorTextLight)">${count} items</div>` : ''}
    </div>
  `;
}
